module.exports = __webpack_public_path__ + "static/logo2-6f2c1ae17fab0550e38cc7fc31c84d51.png";